import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4uyrnv7cr8: FaireBrandEntity = {
  token: "b_4uyrnv7cr8",
  type: "brand",
  name: "Live Linen",
  avatarUrl:
    "https://cdn.faire.com/fastly/f71374f522fcf16064e63105eb2828a29b069b8c1a50e3cda3191c187513c498.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/591bb57b56016d029608e9626572d23055564c064774bc33e11360a7b975c830.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f71374f522fcf16064e63105eb2828a29b069b8c1a50e3cda3191c187513c498.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/591bb57b56016d029608e9626572d23055564c064774bc33e11360a7b975c830.jpeg",
  location: "New Brunswick, NJ, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 70,
  isInsider: true,
  description:
    "The story takes root in the picturesque city of Jaipur, where we grow the essence of simplicity and beauty in embracing the simplest and most detailed things in existence. India, being the realm of culture, heritage, and traditions, connects you with us on another level. The very reason Linen becomes an ideal fabric for us to portray and take our thoughts forward, it's timelessness and prominence epitomise the true essence.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:11:35.617Z",
    importedBy: "entity-db-cli",
  },
};
